import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories, featuredComics, latestUpdates, allCategoryComics } from '@/mocks/comics';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const displayName = category?.name || slug || '未知分类';

  const allComics = [...featuredComics, ...latestUpdates, ...allCategoryComics];
  const categoryComics = allComics.filter((c) => c.categorySlug === slug);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <div className="pt-16">
        <Breadcrumb items={[{ label: '首页', href: '/' }, { label: displayName }]} />
      </div>

      <main>
        <section className="relative w-full h-[320px] md:h-[400px] flex items-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20category%20background%20art%2C%20warm%20coral%20and%20cream%20ambient%20lighting%2C%20soft%20atmospheric%20illustration%2C%20elegant%20minimalist%20design%2C%20warm%20golden%20tone&width=1800&height=600&seq=manhwa-category-hero&orientation=landscape"
            alt={displayName}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
          <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-3 tracking-wide">{displayName}</h1>
            <p className="text-background-50/75 text-sm md:text-base">共 {categoryComics.length} 部作品等你来探索</p>
          </div>
        </section>

        <section className="py-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <h2 className="text-2xl font-heading text-foreground-900 mb-8">分类精选</h2>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-5 md:gap-6">
              {categoryComics.length > 0 ? (
                categoryComics.map((comic) => (
                  <Link
                    key={comic.id}
                    to={`/comic/${comic.slug}`}
                    className="group relative aspect-[3/4] rounded-xl overflow-hidden cursor-pointer"
                  >
                    <img src={comic.coverImage} alt={comic.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent"></div>
                    <div className="absolute top-3 left-3">
                      <span className="inline-block px-2.5 py-1 bg-accent-500 text-foreground-950 text-xs font-medium rounded-full">{comic.category}</span>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-4">
                      <h3 className="text-background-50 font-heading text-lg mb-1.5">{comic.title}</h3>
                      <div className="flex items-center gap-3 text-background-50/80 text-xs">
                        <span className="flex items-center gap-1"><i className="ri-star-fill text-accent-400 text-xs"></i>{comic.rating}</span>
                        <span>{comic.author}</span>
                      </div>
                    </div>
                  </Link>
                ))
              ) : (
                <div className="col-span-3 text-center py-20">
                  <i className="ri-emotion-sad-line text-4xl text-foreground-300 mb-3 block"></i>
                  <p className="text-foreground-500">该分类暂无漫画，敬请期待！</p>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}